import styled from "styled-components"
import media from "styled-media-query"

export const Wrapper = styled.section`
  width: 90%;
  margin: 8px 14px;
  max-width: 365px;
  min-height: 452px;
  max-height: 452px;
  position: relative;
  border-radius: 5px;
  overflow: hidden;
  -webkit-box-shadow: 0px 0px 5px 0px rgba(178, 178, 178, 0.2);
  -moz-box-shadow: 0px 0px 5px 0px rgba(178, 178, 178, 0.2);
  box-shadow: 0px 0px 5px 0px rgba(178, 178, 178, 0.2);
  margin-bottom: 30px;
  transition: all 0.09s ease;

  ${media.lessThan("large")`
    max-width: 350px;
  `}

  ${media.lessThan("medium")`
    max-width: 350px;
  `}

  ${media.lessThan("small")`
  min-height: 412px;
  max-height: 412px;
  width: 80%;
`}

${media.lessThan("340px")`
  width: 90%;
`}

  &:hover {
    transform: translateY(-6px);
    -webkit-box-shadow: 0px 3px 6px 0px rgba(178, 178, 178, 0.4);
    -moz-box-shadow: 0px 3px 6px 0px rgba(178, 178, 178, 0.4);
    box-shadow: 0px 3px 6px 0px rgba(178, 178, 178, 0.4);
  }
`

export const Link = styled.a`
  height: 452px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`
export const Image = styled.img`
  width: 100%;
  height: 231px;

  ${media.lessThan("small")`
    height: 190px;
  `}
`

export const Tag = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  position: absolute;
  top: 222px;
  left: 26px;
  padding: 5px 0;

  width: 75px;
  max-width: 75px;
  max-height: 22px;
  font-size: 14px;
  line-height: 17px;

  color: #fff;
  background: #222;
  text-transform: capitalize;

  ${media.lessThan("small")`
    top: 181px;
  `}
`

export const Info = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  height: 222px;
  padding: 40px 0 25px 0;
  background-color: var(--cardPost);

  ${media.lessThan("small")`
    height: 100%;
    padding: 30px 0 70px 0;
`}
`

export const Title = styled.h1`
  font-weight: 600;
  font-size: 24px;
  line-height: 29px;
  color: #000000;
  text-align: center;
  max-width: 250px;
`

export const Author = styled.span`
  font-weight: 500;
  font-size: 15px;
  line-height: 17px;
  color: #000000;
`

export const Name = styled(Author)`
  color: #00d07e;
`
